"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeControl = exports.decodeGyro = exports.decodeAccel = exports.decodeIMU = exports.decodeTelemetry = exports.decodePPGSamples = exports.decodeEEGSamples = exports.sendCommand = exports.write = exports.encodeCommand = exports.MUSE = void 0;
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const operators_1 = require("rxjs/operators");
const c = __importStar(require("./constants"));
const ble_utils_1 = require("./ble-utils");
exports.MUSE = bluetooth_le_1.numberToUUID(c.MUSE_SERVICE);
function encodeCommand(cmd) {
    const encoded = new TextEncoder().encode(`X${cmd}\n`);
    encoded[0] = encoded.length - 1;
    return encoded;
}
exports.encodeCommand = encodeCommand;
async function write(deviceId, cmd) {
    return bluetooth_le_1.BleClient.writeWithoutResponse(deviceId, exports.MUSE, c.MUSE_GATT_ATTR_STREAM_TOGGLE, cmd);
}
exports.write = write;
async function sendCommand(deviceId, cmd) {
    const command = encodeCommand(cmd).buffer;
    const view = new DataView(command);
    await write(deviceId, view);
}
exports.sendCommand = sendCommand;
function decodeEEGSamples(samples) {
    return ble_utils_1.decodeUint12BitData(samples).map((n) => c.MUESE_EEG_SCALE_FACTOR * (n - 0x800));
}
exports.decodeEEGSamples = decodeEEGSamples;
function decodePPGSamples(samples) {
    return ble_utils_1.decodeUint24BitData(samples);
}
exports.decodePPGSamples = decodePPGSamples;
function decodeTelemetry(data) {
    return {
        sequenceId: data.getUint16(0),
        batteryLevel: data.getUint16(2) / 512,
        fuelGaugeVoltage: data.getUint16(4) * 2.2,
        // TODO: next 2 bytes, ADC millivolt?? check muse-lsl
        temperature: data.getUint16(8),
    };
}
exports.decodeTelemetry = decodeTelemetry;
function decodeIMU(data, scale) {
    // data 9 x samples[int16]
    function sample(start) {
        return {
            x: scale * data.getInt16(start),
            y: scale * data.getInt16(start + 2),
            z: scale * data.getInt16(start + 4),
        };
    }
    return [sample(2), sample(8), sample(14)];
}
exports.decodeIMU = decodeIMU;
function decodeAccel(data) {
    return decodeIMU(data, c.MUSE_ACCELEROMETER_SCALE_FACTOR);
}
exports.decodeAccel = decodeAccel;
function decodeGyro(data) {
    return decodeIMU(data, c.MUSE_GYRO_SCALE_FACTOR);
}
exports.decodeGyro = decodeGyro;
function decodeControl(data) {
    return data.pipe(operators_1.concatMap((d) => d.split('')), operators_1.scan((acc, val) => {
        if (acc.indexOf('}') >= 0)
            return val;
        else
            return acc + val;
    }, ''), operators_1.filter((v) => v.indexOf('}') >= 0), operators_1.map((v) => JSON.parse(v)));
}
exports.decodeControl = decodeControl;
//# sourceMappingURL=muse-utils.js.map